export default __webpack_public_path__ + "static/media/2728 cutlery top.833787da.png";